"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateExpression = void 0;
const get_1 = __importDefault(require("lodash/get"));
function evaluateExpression(expr, values) {
    switch (expr.exprType) {
        case 'column':
            return (0, get_1.default)(values, expr.columnName);
        case 'placeholder':
            return values.__placeholder;
        case 'value':
            return expr.value;
        case 'raw':
            return expr.sql;
        case 'call':
            return null;
        case 'methodCall':
            return null;
        case 'transform':
            return null;
    }
}
exports.evaluateExpression = evaluateExpression;
